import { Epic } from 'redux-observable';
import { EMPTY, Observable } from 'rxjs';

import { Action } from '../actions';
import { RegionFetchSuggestListAction, REGIONS_FETCH_SUGGEST_LIST, regionSetSuggestList } from '../actions/regions';
import { LangUtils } from '../service/Lang/Lang';
import { EpicDeps } from '../service/StoreFactory';
import { MapApiSuggestRequestSearchType } from '../service/YandexMapHelper/YandexMapHelper';
import { RegionSuggestElem } from '../typings/regions';
import { State } from '../typings/state';

const SUGGEST_VERSION = 9;
const LANG = LangUtils.getCurrentLang();
const DEBOUNCE_TIME = 200;

export const regionFetchSuggestListEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) => {
    return action$
        .ofType(REGIONS_FETCH_SUGGEST_LIST)
        .debounceTime(DEBOUNCE_TIME)
        .mergeMap(
            (action: RegionFetchSuggestListAction): Observable<Action> => {
                return Observable.fromPromise(
                    deps.entitiesDataProvider.getMapApiSuggestItems({
                        part: action.part,
                        search_type: MapApiSuggestRequestSearchType.tune,
                        v: SUGGEST_VERSION,
                        n: action.itemsCount,
                        lang: LANG
                    })
                )
                    .map((suggestList: RegionSuggestElem[]) => regionSetSuggestList(action.regionInputId, suggestList))
                    .catch(() => EMPTY);
            }
        );
};
